module.exports = "/_next/static/images/a9280ec12dd73805117c74e5a8070671-cash-advances.gif.webp";